import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { Stars } from './Stars';
import { reviews } from '../data/reviews';
export function Reviews() {
  const [featured, ...rest] = reviews;
  return <section id="reviews" className="bg-white py-20 lg:py-28" data-id="element-318" data-mp="2mb5qh99m60m0">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-319" data-mp="2mdrw33cy261l">
        <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.95] text-ink lg:text-6xl" data-id="element-320" data-mp="2rbtern6gk3cj">
          Neighbors who <span className="text-brand" data-id="element-321" data-mp="2w9mlqifl51dv">called the doctor</span>
        </h2>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.2fr_1fr]" data-id="element-322" data-mp="30aexpjfudkdu">
          <figure className="flex flex-col rounded-2xl bg-brand p-8 text-white sm:p-10" data-id="element-323" data-mp="352gi5sn5yhey">
            <QuoteIcon className="h-10 w-10 text-white/40" aria-hidden="true" data-id="element-324" data-mp="3a19s5b38rqad" />
            <blockquote className="mt-5 font-display text-3xl font-semibold leading-snug sm:text-4xl" data-id="element-325" data-mp="3a3dzk30cn7fe">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-auto flex items-center justify-between gap-4 pt-8" data-id="element-326" data-mp="3k08ukbxeypox">
              <div data-id="element-327" data-mp="2rdp1hmaw7f64">
                <p className="font-display text-xl font-bold" data-id="element-328" data-mp="2re8jt44gg5ko">{featured.name}</p>
                <p className="text-sm text-white/80" data-id="element-329" data-mp="2mcj6fhtrfftf">{featured.location}</p>
              </div>
              <Stars data-id="element-330" data-mp="2hfj2bcgh0n4y" />
            </figcaption>
          </figure>

          <div className="grid gap-6" data-id="element-331" data-mp="2dd5wyp5myr8p">
            {rest.map(r => <figure key={r.name} className="flex flex-col rounded-2xl bg-canvas p-7" data-id="element-332" data-mp="2dez74efgjtlg">
                <div className="flex items-center justify-between gap-4" data-id="element-333" data-mp="3a2dihx6990cm">
                  <p className="font-display text-2xl font-bold text-ink" data-id="element-334" data-mp="355ddlpl563n3">{r.title}</p>
                  <Stars data-id="element-335" data-mp="30ckbzakyzbf8" />
                </div>
                <blockquote className="mt-3 leading-relaxed text-ink-muted" data-id="element-336" data-mp="30b94azoeljiu">“{r.quote}”</blockquote>
                <figcaption className="mt-auto pt-5" data-id="element-337" data-mp="2w9nu5m397jcc">
                  <span className="font-bold text-ink" data-id="element-338" data-mp="3suoh3etvmc4x">{r.name}</span>
                  <span className="text-ink-muted" data-id="element-339" data-mp="3o36fcok147iw"> · {r.location}</span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}